<template>
    <header class="fixed-top" id="navbar">
        <nav class="navbar navbar-expand-lg navbar-light d-none d-lg-flex pt-n1" style="border-bottom: 1px solid rgb(227, 230, 235);">
            <div class="navbar-nav">
                <span class="nav-item nav-link-header ml-1 mr-4" href="#">Realtime, Fast, Product Data API. Learn more.</span>
            </div>
            <div class="navbar-nav ml-auto">
                <a class="nav-item nav-link-header mr-4" href="#">Docs</a>
                <a class="nav-item nav-link-header mr-4" href="#">Support</a>
                <a class="nav-item nav-link-header mr-4" href="#">Sales</a>
                <a class="nav-item nav-link-header mr-3" href="#">Sign In</a>
            </div>
        </nav>
        <nav class="navbar navbar-expand-lg navbar-light shadow-sm">
            <i class="la la-terminal my-auto ml-1 mr-2"></i>
            <router-link class="navbar-brand my-auto mr-5" to="/">PD-API</router-link>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav">
                    <router-link class="nav-item nav-link mr-4" to="/">Product Info API <i class="fas fa-caret-right ml-1"></i></router-link>
                    <a class="nav-item nav-link mr-4" href="#">Developers</a>
                    <a class="nav-item nav-link mr-4" href="#">Company</a>
                    <a class="nav-item nav-link mr-4" href="#">Pricing</a>
                </div>
                <div class="navbar-nav ml-auto">
                    <button class="btn btn-lg btn-primary-light ml-auto mr-3">
                        Sign Up
                    </button>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {

}
</script>

<style scoped>
.btn-primary-light {
    border-radius: 7px;
    font-size: 11pt;
    font-weight: 700;
    transition: all .5s;
}

.navbar-brand {
    font-size: 18pt;
    font-weight: 800;
    color: rgb(19, 110, 251);
    transition: all .2s;
}

.navbar-light {
    background: #ffffff;
}

.la-terminal {
    color: rgb(19, 110, 251);
    font-size: 25pt;
}

.nav-link {
    color: rgb(0, 0, 0) !important;
    border-radius: 25px;
    font-size: 11pt;
    font-weight: 500;
    transition: all .3s
}

.nav-link-header {
    color: rgb(100, 100, 100);
    font-size: 9pt;
    font-weight: 500;
}
</style>